import { CollectionPreferences, CollectionPreferencesProps } from '@amzn/awsui-components-react-v3';
import React, { ReactElement } from 'react';

export type TablePreferencesProps = {
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  visibleColumns: string[];
  setVisibleColumns: (columns: string[]) => void;
  pageSizePreferences: CollectionPreferencesProps.PageSizePreference;
  visibleContentPreferences: CollectionPreferencesProps.VisibleContentPreference;
  onPreferenceChange: (preference: CollectionPreferencesProps.Preferences) => void;
};

export default function TablePreferences({
  pageSize,
  pageSizePreferences,
  visibleContentPreferences,
  visibleColumns,
  onPreferenceChange,
}: TablePreferencesProps): ReactElement {
  return (
    <CollectionPreferences
      title="Preferences"
      confirmLabel="Confirm"
      cancelLabel="Cancel"
      preferences={{
        pageSize,
        visibleContent: visibleColumns,
      }}
      pageSizePreference={pageSizePreferences}
      visibleContentPreference={visibleContentPreferences}
      onConfirm={(e) => onPreferenceChange(e.detail)}
    />
  );
}
